var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_902_1772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89172 9.74768L8.2352 6.3114C8.36324 6.22903 8.46955 6.1107 8.54345 5.96828C8.61735 5.82585 8.65625 5.66434 8.65625 5.49994C8.65625 5.33554 8.61735 5.17403 8.54345 5.03161C8.46955 4.88919 8.36324 4.77085 8.2352 4.68848L8.2352 4.68879L2.89172 1.2522C2.7635 1.16963 2.61796 1.12605 2.46975 1.12586C2.32155 1.12566 2.17591 1.16886 2.04751 1.2511C1.91911 1.33334 1.81248 1.45172 1.73836 1.59431C1.66423 1.73691 1.62523 1.89869 1.62528 2.06336L1.62528 8.93653C1.62523 9.1012 1.66423 9.26298 1.73836 9.40557C1.81248 9.54817 1.91911 9.66655 2.04751 9.74879C2.17591 9.83103 2.32155 9.87422 2.46975 9.87403C2.61796 9.87384 2.7635 9.83026 2.89172 9.74768Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_902_1772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9,
    fill: "white",
    transform: "translate(9.5 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleIcon);
export default __webpack_public_path__ + "static/media/triangle-icon.b466795de134b198aeec57c20f2aa6dc.svg";
export { ForwardRef as ReactComponent };